var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileMicOn = function SvgMobileMicOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3",
    "data-name": "Path 1064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10v2a7 7 0 0 1-14 0v-2",
    "data-name": "Path 1065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19v4",
    "data-name": "Line 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 23h8",
    "data-name": "Line 13"
  }))));
};
export default SvgMobileMicOn;